import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext, watch } from "@nuxtjs/composition-api";
import { MetaUser } from "~/core/models/MetaUser";
import { AUTH_FLOW_STEPS } from "~/core/services/utils/Constants";
import ApiService from "~/core/services/api-interaction/ApiService";

interface Props {
    visible: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorAuthenticationReminder',
  props: {
    visible: { type: Boolean, default: false }
  },
  emits: ['onPopupClose'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible: boolean };





const {
    visible,
} = toRefs(props);

const turnOffLoading = ref(false);

const context = useContext();
const user: MetaUser = computed(() => context.store.getters['application/driver/authUser']);

const internalVisible = ref(visible.value);

const handleContinue = () => {
    context.store.dispatch('application/driver/setAuthStep', AUTH_FLOW_STEPS.TWO_FACTOR_CODE);
    context.store.dispatch('application/popup-control/changeConnectWalletPopupStatus', true);
    internalVisible.value = false;
}

const handleTurnOff = async () => {
    turnOffLoading.value = true;
    try {
        await ApiService.post('/user/two-factor-auth-status');
        context.store.commit('application/driver/UPDATE_AUTH_USER', {
            isEnableTwoFactor: false,
        });
        await context.store.dispatch('application/popup-control/onTwoFactorAuthenticationVisible', false);
    } catch (e) {
        console.log('Don’t Ask Me Again :', e);
    } finally {
        turnOffLoading.value = false;
    }
}

watch(visible, (newValue) => {
    internalVisible.value = newValue;
})

return { __sfc: true,props, $emit, visible, turnOffLoading, context, user, internalVisible, handleContinue, handleTurnOff }
}

})